export const home = "/paravoce/";

export const seguroSaude = "/paravoce/seguro-saude";
export const seguroSaudeResultados = "/paravoce/seguro-saude/resultados";
